import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as String_array_wrap$SolvuuApi0 from "./string_array_wrap.bs.js";
import * as String_matrix_wrap$SolvuuApi0 from "./string_matrix_wrap.bs.js";

function write__1(param) {
  return Atdgen_codec_runtime.Encode.list(Atdgen_codec_runtime.Encode.string, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.list(Atdgen_codec_runtime.Decode.string, param);
}

function write__3(param) {
  return Atdgen_codec_runtime.Encode.list(write__1, param);
}

function read__3(param) {
  return Atdgen_codec_runtime.Decode.list(read__1, param);
}

function write__4(param) {
  return Atdgen_codec_runtime.Encode.contramap(String_matrix_wrap$SolvuuApi0.unwrap, write__3, param);
}

function read__4(param) {
  return Atdgen_codec_runtime.Decode.map(String_matrix_wrap$SolvuuApi0.wrap, read__3, param);
}

function write__2(param) {
  return Atdgen_codec_runtime.Encode.contramap(String_array_wrap$SolvuuApi0.unwrap, write__1, param);
}

function read__2(param) {
  return Atdgen_codec_runtime.Decode.map(String_array_wrap$SolvuuApi0.wrap, read__1, param);
}

var write_t = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x[0] >= -83649777) {
    return Atdgen_codec_runtime.Encode.constr1("String_matrix", write__4, x[1]);
  } else {
    return Atdgen_codec_runtime.Encode.constr1("String_array", write__2, x[1]);
  }
});
var read_t = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["String_array",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `String_array */
      [-867361653, x]
    );
  }, read__2, param);
}]],
/* :: */
[
/* tuple */
["String_matrix",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `String_matrix */
      [-83649777, x]
    );
  }, read__4, param);
}]],
/* [] */
0]]);
var write_term = Atdgen_codec_runtime.Encode.make(function (x) {
  return Atdgen_codec_runtime.Encode.constr1("Strings", write_t, x[1]);
});
var read_term = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Strings",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Strings */
      [-968575390, x]
    );
  }, read_t, param);
}]],
/* [] */
0]);
var read_string_matrix = read__4;
var write_string_matrix = write__4;
var read_string_array = read__2;
var write_string_array = write__2;
export { read_string_matrix, write_string_matrix, read_string_array, write_string_array, read_t, write_t, read_term, write_term };
/* write_t Not a pure module */